import { useEffect } from 'react';

const SITE = 'Albambam';
const ORIGIN = 'https://albambam.com';

function setMeta(attr, name, content) {
    let el = document.head.querySelector(`meta[${attr}="${name}"]`);
    if (!content) return;
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
}

// Per-route SEO: updates title, meta description, Open Graph, canonical and
// JSON-LD structured data. Googlebot executes JS, so these tags are indexed.
export function Seo({ title, description, path, jsonLd }) {
    useEffect(() => {
        const fullTitle = title ? `${title} · ${SITE}` : `${SITE} · Vídeos i Shorts en català`;
        document.title = fullTitle;
        const desc = description || 'Albambam és la plataforma de vídeo en català: mira i comparteix vídeos i shorts, descobreix creadors per categories.';
        setMeta('name', 'description', desc);
        setMeta('property', 'og:title', fullTitle);
        setMeta('property', 'og:description', desc);
        setMeta('name', 'twitter:title', fullTitle);
        setMeta('name', 'twitter:description', desc);
        const url = `${ORIGIN}${path || '/'}`;
        setMeta('property', 'og:url', url);
        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', url);
        let script = document.getElementById('seo-route-jsonld');
        if (jsonLd) {
            if (!script) {
                script = document.createElement('script');
                script.type = 'application/ld+json';
                script.id = 'seo-route-jsonld';
                document.head.appendChild(script);
            }
            script.textContent = JSON.stringify(jsonLd);
        } else if (script) {
            script.remove();
        }
    }, [title, description, path, jsonLd]);
    return null;
}
